import { render, staticRenderFns } from "./Suitfor.vue?vue&type=template&id=359b7948&scoped=true"
import script from "./Suitfor.vue?vue&type=script&lang=js"
export * from "./Suitfor.vue?vue&type=script&lang=js"
import style0 from "./Suitfor.vue?vue&type=style&index=0&id=359b7948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b7948",
  null
  
)

export default component.exports